<template>
  <div>
    <table>
      <pt-form-list-item label="信息类型：">
        <wt-radio :radios="radios" v-model="form.type"></wt-radio>
      </pt-form-list-item>
      <template v-if="form.type==='action'">
        <pt-form-list-item label="新闻分类：">
          <wt-selector :options="newsCategories" :props="newsCategoriesProps" v-model="newsCategory"></wt-selector>
        </pt-form-list-item>
        <pt-form-list-item label="新闻标题：">
          <wt-selector @visible-change="visibleChange" :options="newsList" :props="newsProps" v-model="newsId"
            :loading="newsLoading"></wt-selector>
        </pt-form-list-item>
      </template>
    </table>
    <template v-if="form.type=='goods'">
      <select-for-goods :isSelectButton="false" :selected-goods="selectedGoods" select-type="radio"
        @selectMealRow="selectMealRow">
      </select-for-goods>
    </template>
    <template v-if="form.type==='promotion'">
      <select-active-list :isSubmit="false" @selectPromotion="selectPromotion"></select-active-list>
    </template>
    <template v-if="form.type==='poster'">
      <pt-form-list-item label="选择海报：">
          <wt-selector :options="posterList" :props="posterProps" v-model="posterIds" :multiple="true"></wt-selector>
      </pt-form-list-item>
    </template>
    <div class="button-div">
      <el-button type="primary" @click.native="submit" :loading="loading">保存</el-button>
      <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
  </div>
</template>
<script>
import {
  setMessageType
} from '../banner-options'
import selectForGoods from '../../../select-for-goods'
import selectActiveList from '../../pt-active-setting/select-active-list'
export default {
  components: {
    selectForGoods,
    selectActiveList
  },
  props: {
    resuoresId: {
      type: String,
      default: ''
    },
    bannerType: {
      type: String,
      default: ''
    },
    currentItem: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      radios: setMessageType,
      form: {
        type: 'action'
      },
      selectIndex: '',
      selectedGoods: {},
      loading: false,
      newsLoading: false,
      newsCategories: [],
      newsCategory: '',
      newsCategoriesProps: {
        label: 'name',
        value: 'id'
      },
      newsProps: {
        label: 'title',
        value: 'id'
      },
      posterProps: {
        label: 'name',
        value: 'id'
      },
      newsList: [],
      posterList: [],
      newsId: '',
      posterIds: [],
      selectRow: {}
    }
  },
  watch: {
    newsCategory: {
      handler: function (val) {
        if (val) {
          this.getNewsList()
        }
      }
    }
  },
  methods: {
    selectPromotion (val) {
      this.selectRow = val
    },
    visibleChange () {
      this.getNewsList()
    },
    selectMealRow (val) {
      this.selectedGoods = val
    },
    cancel () {
      this.$emit('close')
    },
    getNewCategories () {
      this.$store.dispatch('newCategories').then(res => {
        this.newsCategories = res
      }).catch(err => {
        this.$message.error(err || '获取新闻分类失败')
      })
    },
    getNewsList () {
      let data = {
        categoryId: this.newsCategory || null,
        pageable: {
          page: 0,
          size: 99999
        }
      }
      this.newsLoading = true
      this.$store.dispatch('getNewsList', data).then(res => {
        this.newsLoading = false
        this.newsList = res.data
      }).catch(err => {
        this.newsLoading = false
        this.$message.error(err || '获取新闻列表失败')
      })
    },
    getPosterList () {
      let data = {
        pageable: {
          page: 0,
          size: 9999
        },
        example: {
          published: true
        }
      }
      this.loading = true
      this.$store.dispatch('getPosterList', data).then(res => {
        this.loading = false
        this.posterList = res.data
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取海报列表失败')
      })
    },
    submit () {
      // console.log('this.currentItem', this.currentItem)
      // if (this.currentItem.description) {
      //   this.$confirm(`是否要覆盖原图片设置${this.currentItem.description ? ':"' + this.currentItem.description + '"' : ''}?`, '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     this.updateInfo()
      //   })
      // } else {
      this.updateInfo()
      // }
    },
    promotionBannerUrl () {
      let data = {
        promotionEventId: this.selectRow.id,
        bannerType: this.bannerType
      }
      this.loading = true
      this.$store.dispatch('promotionBannerUrl', data).then(res => {
        this.$emit('selectSubmit', res)
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取活动信息失败')
      })
    },
    posterBannerUrl () {
      let url = '/general-share-poster?ids=' + this.posterIds
      let data = { url: url, description: '我的报告海报' }
      this.$emit('selectSubmit', data)
    },
    updateInfo () {
      if (this.form.type === 'goods') {
        this.bannerGoodsResources()
      } else if (this.form.type === 'action') {
        this.bannerNewsResouces()
      } else if (this.form.type === 'promotion') {
        this.promotionBannerUrl()
      } else if (this.form.type === 'poster') {
        this.posterBannerUrl()
      }
    },
    bannerGoodsResources () {
      let data = {
        id: this.selectedGoods.goodsDTO.id,
        type: this.bannerType
      }
      this.loading = true
      this.$store.dispatch('bannerGoodsResources', data).then(res => {
        this.$emit('selectSubmit', res)
        this.loading = false
        this.$message.success('获取广告位资源成功')
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取广告位资源失败')
      })
    },
    bannerNewsResouces () {
      let data = {
        id: this.newsId,
        type: this.bannerType
      }
      this.loading = true
      this.$store.dispatch('bannerNewsResouces', data).then(res => {
        this.$emit('selectSubmit', res)
        this.loading = false
        this.$message.success('获取广告位资源成功')
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取广告位资源失败')
      })
    }
  },
  created () {
    this.getNewCategories()
    this.getPosterList()
    if (this.currentItem) {
      this.posterIds = this.currentItem.url.split('=')[1] ? (this.currentItem.url.split('=')[1]).split(',') : []
    }
  }
}

</script>
<style module lang="less">
  @import "~less/var";

  .goods-list-radio {
    :global .el-radio__label {
      display: none;
    }

    :global .el-radio__inner {
      border: 1px solid @mainColor;
      border-radius: 50%
    }
  }

</style>
